import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { AsyncPipe } from '@angular/common';
import { BaseAppComponent } from '@ui/shared/feature-config';
import type { CultureMapItemModel } from './entities/culture-map-item.model';
import { CultureMapItemPopupContentComponent } from './components/culture-map-item-popup-content/culture-map-item-popup-content.component';
import { CultureMapItemDetailsComponent } from './components/culture-map-item-details/culture-map-item-details.component';
import { FilterMapperComponent } from '@ui/shared/ui-filter';

@Component({
    selector: 'ui-culture-map-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        MapWithSidebarModule,
        FilterMapperComponent,
        CultureMapItemDetailsComponent,
    ],
})
export class AppComponent extends BaseAppComponent<CultureMapItemModel> {
    constructor() {
        super(CultureMapItemPopupContentComponent);
    }
}
